import { HOST_URL } from '~/constants/config';

export const getFeedMetaTags = () => {
  return {
    link: [
      //
      { hid: 'canonical', rel: 'canonical', href: HOST_URL },
    ],
  };
};
